import React from 'react';

import { format } from 'date-fns';

export const gridConfig = {
  columns: [
    {
      component: ({ value }: any) => (
        <span dangerouslySetInnerHTML={{ __html: value }} />
      ),
      name: 'title',
      title: 'Title',
    },
    {
      component: ({ value }: any) => <span>{value ? 'yes' : 'no'}</span>,
      name: 'isPublished',
      title: 'Published',
    },
    {
      component: ({ value }: any) => (
        <span>{value ? format(new Date(value), 'dd/MM/yyyy') : null}</span>
      ),
      name: 'publishDate',
      title: 'Publish date',
    },
    {
      name: 'categoryName',
      title: 'Category',
    },
  ],
  title: 'Articles',
};
